var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-list"},_vm._l((_vm.sortedFields),function(field,idx){return _c('table-field',{key:field.name,attrs:{"field":field,"readonly":_vm.readonly},on:{"add":function($event){return _vm.onAdd(idx)},"remove":function($event){return _vm.onRemove(idx)},"change":function($event){return _vm.onChange(idx)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }